import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import rootReducer from "./rootReducer";

/*
Customize what’s persisted
We can customize a part of our state to persist by using the blacklist and whitelist properties
of the config object passed to persistReducer. With the blacklist property, we can specify which part of state not to persist,
while the whitelist property does the opposite, specifying which part of the state to persist.

The blacklist and whitelist properties take an array of strings. 
Each string must match a part of the state that is managed by the reducer we pass to persistReducer.
 When using blacklist and whitelist, we can only target one level deep. But, 
 if we want to target a property in one of our states above, we can take advantage of nested persist.
*/

const rootPersistConfig = {
  key: "root",
  storage,
  whitelist: [""], //Specify the slices to persist
  // blacklist: [""],
};

// example
// export const incidentPersistConfig = {
//   key: "incident",
//   storage,
//   whitelist: ["incidentSearchTerm"],
//   // blacklist: ["incidentSearchTerm"],
// };

const persistedReducer = persistReducer(rootPersistConfig, rootReducer);

export default persistedReducer;
